import ReactDOM from "react-dom";
import React, { useState } from 'react'
import langData from '../locales/langData.json'
import vonescroll from '../assets/images/videoscroll1.png'
import vonescrol2 from '../assets/images/videoscroll2.png'
import vonescrol3 from '../assets/images/videoscroll3.png'
import vonescrol4 from '../assets/images/videoscroll4.png'
import vonescrol5 from '../assets/images/videoscroll5.png'
import vonescrol6 from '../assets/images/videoscroll6.png'
import vonescrol7 from '../assets/images/videoscroll7.png'
import vonescrol8 from '../assets/images/videoscroll8.png'
import FallingText from "../components/FallingText";
import { Link } from "react-router-dom";
import arrow from '../assets/images/right-arrow.webp'
import SEO from '../components/SEO'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import CareerForm from "../components/Forms/CareersForm";
import StickyTabs from "../components/StickyTabs";

const Talent = ({ language }) => {
    const [showModal, setShowModal] = useState(false);
    const Launchpad = langData[language].Launchpad;
    const sportcareer = langData[language].sportcareer;
    const carrcta = langData[language].carrcta;
    // const [showPanel, setShowPanel] = useState(false);


    //     useEffect(() => {
    //   if (showPanel) {
    //     document.body.style.overflow = "hidden";   // disable background scroll
    //   } else {
    //     document.body.style.overflow = "auto";     // enable back
    //   }

    //   return () => {
    //     document.body.style.overflow = "auto";
    //   };
    // }, [showPanel]);

const formLinks = {
  en: "https://docs.google.com/forms/d/e/1FAIpQLSdLFRHpe-KpnRpeFGnD6eA74otFMpp1YXEz_o-TPF0DsG6XbA/viewform?usp=dialog",
  ar: "https://docs.google.com/forms/d/1K-8VzTUe4YYf7qdwPDuvQyH2Ykw5QnrlGHFXfoOHp-c/edit?usp=sharing_eil_se_dm&ts=6965fe37"
};

    return (
        <>
            <SEO
                title="Talent Forge | CaptainX Sports Technology Launchpad"
                titleAr="برنامج المواهب | منصة كابتن اكس لتكنولوجيا الرياضة"
                description="Launch your career in sports technology with CaptainX Talent Forge. Join our launchpad program under Saudi Vision 2030."
                descriptionAr="انطلق في مسيرتك المهنية في تكنولوجيا الرياضة مع برنامج المواهب من كابتن اكس. انضم إلى برنامجنا في إطار رؤية السعودية 2030."
                path="/careers/talent"
                language={language}
            />

            {showModal &&
                ReactDOM.createPortal(
                    <CareerForm onClose={() => setShowModal(false)} />,
                    document.body
                )
            }

            <section className="launchpad">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-md-7 pt-5 md-pt-0">
                            <h2 className="sec-title">
                                {Launchpad.title}
                            </h2>
                            <p className="sec-p-text">
                                {Launchpad.desc1}
                            </p>
                            <p className="sec-p" dangerouslySetInnerHTML={{ __html: Launchpad.desc2 }}></p>

                                         <Link
  to={language === "ar" ? formLinks.ar : formLinks.en}
  target="_blank"
  rel="noopener noreferrer"
  className="under-line"
>
  <button
    type="button"
    className={`explore-btn cta-btn mt-4 pt-2 gap-3 ${
      language === "ar" ? "ar-padding" : "en-padding"
    }`}
  >
    {carrcta.btn}
    <img src={arrow} alt="arrow" className="rt-btn" />
  </button>
</Link>
                        </div>
                        <div className="col-md-5">
                            <div className="center-scroll-anim">

                                {/* Column 1 - scrolling UP */}
                                <div className="v-marquee">
                                    {[vonescroll, vonescrol2, vonescrol3, vonescrol4].map((img, i) => (
                                        <img key={i} src={img} alt="slide-img" />
                                    ))}

                                    {/* Duplicate for infinite scrolling */}
                                    {[vonescroll, vonescrol2, vonescrol3, vonescrol4].map((img, i) => (
                                        <img key={`dup1-${i}`} src={img} alt="slide-img" />
                                    ))}
                                </div>

                                {/* Column 2 - scrolling DOWN */}
                                <div className="v-marquee reverse">
                                    {[vonescrol5, vonescrol6, vonescrol7, vonescrol8].map((img, i) => (
                                        <img key={i} src={img} alt="slide-img" />
                                    ))}

                                    {/* Duplicate */}
                                    {[vonescrol5, vonescrol6, vonescrol7, vonescrol8].map((img, i) => (
                                        <img key={`dup2-${i}`} src={img} alt="slide-img" />
                                    ))}
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </section>

            <section className='sportx-sec' style={{ background: "#fff" }}>
                <div className="container">
                    <div className="row py-5">
                        <div className="col-md-6">
                            <h6 className='sec-top-titl'>{sportcareer.toptitle}</h6>
                            <h2 className='sec-title'>{sportcareer.title}</h2>

                        </div>
                        <div className="col-md-6"></div>
                    </div>
                    <div className="row">
                        {sportcareer.box.map((card, index) =>
                            <div className="col-md-3 mb-4 card-sportx">
                                <div className="sportx-box " key={index} style={{ color: "#151227", border: "1px solid #000" }}>
                                    <LazyLoadImage src={card.img} alt="wbrain" className='imgfluid pb-1' />
                                    <h4 className='pb-3'>{card.title}</h4>
                                    <p style={{ color: "#151227" }}>{card.desc}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            <section className="who-can-appy">
                <div className="container">
                    <div className="cen-con-sec">
                        <center>
                            <h2 className="sec-title">{Launchpad.falltitle}</h2>
                            <p className="sec-p">{Launchpad.falldesc}</p>
                        </center>
                    </div>
                    <div className="container-bg-fade my-4">
                        <FallingText
                            text={
                                language === "ar"
                                    ? "التسويق الاتصال استراتيجية_الأعمال علوم_الرياضة المحتوى علوم_الحاسوب الذكاء_الاصطناعي الهندسة إدارة_المنتج تحليل_البيانات تصميم_تجربة_المستخدم"
                                    : "Marketing Communication Business&Strategy Sports_Science Content Computer_Science/AI/Engineering  Product_Management Data_Science/Analytics UI/UX/Visual_Design"
                            }
                            highlightWords={
                                language === "ar"
                                    ? [
                                        "التسويق",
                                        "الاتصال",
                                        "استراتيجية_الأعمال",
                                        "علوم_الرياضة",
                                        "المحتوى",
                                        "علوم_الحاسوب",
                                        "الذكاء_الاصطناعي",
                                        "الهندسة",
                                        "إدارة_المنتج",
                                        "تحليل_البيانات",
                                        "تصميم_تجربة_المستخدم"
                                    ]
                                    : [
                                        "Marketing",
                                        "Communication",
                                        "Business&Strategy",
                                        "Sports_Science",
                                        "Content",
                                        "Computer_Science/AI/Engineering",
                                        "Product_Management",
                                        "Data_Science/Analytics",
                                        "UI/UX/Visual_Design"
                                    ]
                            }
                            gravity={1}
                            trigger="onVisible"
                        />
                        
                  
                  
                    </div>
                </div>
            </section>

            <section className="tab-btn-sec">

                <StickyTabs language={language} />

            </section>

            <section className='opening-form'>
                <div className="container">
                    <div className="cen-sec-con my-5">
                        <center>
                            <h2 className="sec-title">
                                {carrcta.title}
                            </h2>
                            <p className="sec-p">
                                {carrcta.desc}
                            </p>
                         
                            <Link
  to={language === "ar" ? formLinks.ar : formLinks.en}
  target="_blank"
  rel="noopener noreferrer"
  className="under-line"
>
  <button
    type="button"
    className={`explore-btn cta-btn mt-4 pt-2 gap-3 ${
      language === "ar" ? "ar-padding" : "en-padding"
    }`}
  >
    {carrcta.btn}
    <img src={arrow} alt="arrow" className="rt-btn" />
  </button>
</Link>

                        </center>


                        {/* SLIDING FORM PANEL */}
                        {/* <div className={`captainx-form ${showPanel ? "active" : ""}`}>

                        
                            <div className="close-captainx-form" onClick={() => setShowPanel(false)}>
                                ✕
                            </div>

                            <CaptainXApply  language={language}/>

                        </div> */}



                    </div>
                </div>
            </section>
        </>
    )
}

export default Talent